export default __webpack_public_path__ + "static/media/Mark-5-HUD-02.0a0bc914.jpg";